import {Component, OnInit} from '@angular/core';
import {DataObjEditComponent, DataObjEditComponentHelper} from '../../rest-service';
import {CostCenter, CostCenterService} from '../../cost-center.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {GlobalValidator} from '../../global-validator';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {NotificationService} from '../../notification.service';
import {isNullOrUndefined} from 'util';
import {UserService} from '../../user.service';

@Component({
  selector: 'app-cost-center-edit',
  templateUrl: './cost-center-edit.component.html',
  styleUrls: ['./cost-center-edit.component.css']
})
export class CostCenterEditComponent implements OnInit, DataObjEditComponent<CostCenter> {

  // name of the object in the singular
  readonly vowelSingular = 'o Centro de Custo';

  readonly entityPath = '/cost_centers';

  helper: DataObjEditComponentHelper<CostCenter>;

  readonly defaultObj = new CostCenter(null, '', 0, null, false);

  controlsConfigs = [{
    'description': ['', Validators.required],
    'number': ['0', GlobalValidator.intValueValidator]
  }];

  validationMessages = [
    {
      'description': {
        'required': 'Descrição não informada'
      },
      'number': {
        'nonInteger': 'Número inválido',
        'required': 'Número não informado'
      },
    }
  ];

  constructor(private fb: FormBuilder, public router: Router, public route: ActivatedRoute, public ns: NotificationService,
              public service: CostCenterService, public us: UserService) {
    this.helper = new DataObjEditComponentHelper(fb, this.controlsConfigs, this.validationMessages, this.entityPath,
      this.router, this.ns, this.service, this);
  }

  ngOnInit() {
    this.helper.buildForm();
    this.route.params.switchMap((params: Params) => {
      const id = params['id'];
      return this.processId(id);
    }).subscribe((obj: CostCenter) => {
      this.helper.actualObj = obj;
      this.toModel(obj, this.helper.formGroups[0]);
    });
    this.helper.formGroups.forEach((formGroup, index, array) =>
      formGroup.valueChanges.debounceTime(250).subscribe((data) => this.helper.onValueChanges(data, index)));
  }

  processId(id: string) {
    if (id && id !== '') {
      this.helper.editing = true;
      return this.service.getById(id);
    } else {
      this.helper.editing = false;
      return Observable.of(this.defaultObj);
    }
  }

  validateFields(index: number, defaultFormErrors: any): Observable<any> {
    if (index === 0) {
      const costCenterNumber = this.helper.formGroups[0].get('number').value;
      if (!isNullOrUndefined(costCenterNumber) && !this.helper.editing) {
        return this.service.countByNumberAndCustomerId(costCenterNumber, this.us.currentUser.getValue().customerDatabaseId)
          .map((value) => {
            if (value !== 0) {
              console.log(`CostCenter Number already used by ${value} cost centers...`);
              if (isNullOrUndefined(defaultFormErrors['number'])) {
                defaultFormErrors['number'] = new Array<string>();
              }
              defaultFormErrors['number'].push('Número de centro de custo já existe');
              this.helper.formInvalid[index] = true;
            }
            return defaultFormErrors;
          });
      } else {
        return Observable.of(defaultFormErrors);
      }
    }
  }

  trySave(index: number, model: any) {
    this.helper.preSave();
    console.log(`Trying to save: ${JSON.stringify(model)}`);
    this.helper.isAllValid(index).subscribe((valid) => {
      if (valid) {
        console.log(`Trying to send to the Rest Service...`);
        const obj = this.fromModel(model);
        this.helper.decideOperation(obj).subscribe((res) => {
          this.helper.processResult(index, res);
          this.helper.formGroups.forEach((formGroup, idx, array) =>
            formGroup.valueChanges.debounceTime(250).subscribe((data) => this.helper.onValueChanges(data, idx)));
        }, (error) => {
          console.log(`Error Saving object: '${obj}': ${JSON.stringify(error)}`);
          this.ns.error(error.toString(), 'Erro ao salvar');
        }, () => this.helper.postSave());
      } else {
        console.log(`NotSaving because something is invalid...`);
        this.helper.postSave();
      }
    }, (error) => {
      this.ns.error(error.toString(), 'Erro ao salvar');
    });
  }

  fromModel(model: any): CostCenter {
    let id = null;
    if (this.helper.editing) {
      id = this.helper.actualObj.id;
    }
    return new CostCenter(id, model.description, model.number, this.us.currentUser.getValue().customerDatabaseId, false);
  }

  toModel(obj: CostCenter, fg: FormGroup) {
    fg.controls['description'].patchValue(obj.description);
    fg.controls['number'].patchValue(obj.number);
  }
}



// WEBPACK FOOTER //
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/cost-center/cost-center-edit/cost-center-edit.component.ts